import request from "../util/request"

export default function () {
  const paymentForm = document.getElementById("js-payment-form")
  if (paymentForm) {
    // Create a Stripe client
    const { stripeAccount, createCardPath, redirectUrl } = paymentForm.dataset
    const stripePublicKey = document.querySelector("meta[name='stripe-public-key']").getAttribute("content")
    const stripe = Stripe(stripePublicKey, { stripeAccount: stripeAccount })
    // Create an instance of Elements
    const elements = stripe.elements()

    const style = {
      base: {
        color: "#32325d",
        lineHeight: "24px",
        fontSmoothing: "antialiased",
        fontFamily: "Roboto, Open Sans, Segoe UI, sans-serif",
        fontSize: "18px",
        "::placeholder": {
          color: "#999999",
        },
      },
      invalid: {
        color: "#fa755a",
        iconColor: "#fa755a",
      },
    }

    // Create an instance of the card Element
    const card = elements.create("card", { style: style })

    // Add an instance of the card Element into the `js-card-element` <div>
    card.mount("#js-card-element")

    // Handle real-time validation errors from the card Element.
    const displayError = document.getElementById("js-card-errors")
    card.addEventListener("change", function (event) {
      if (event.error) {
        displayError.textContent = event.error.message
      } else {
        displayError.textContent = ""
      }
    })

    // Handle form submission
    const form = document.getElementById("js-payment-form")
    const buttonElement = document.getElementById("js-payment-form-submit-button")
    const errorElement = document.getElementById("js-card-errors")
    form.addEventListener("submit", function (event) {
      event.preventDefault()
      buttonElement.innerText = "Saving"
      buttonElement.disabled = true

      stripe.createToken(card).then(function (result) {
        if (result.error) {
          // Inform the user if there was an error
          buttonElement.innerText = "Save"
          buttonElement.disabled = false
          errorElement.textContent = result.error.message
        } else {
          request("POST", createCardPath, {
            source: result.token.id,
          }).then((result) => {
            if (result.success) {
              window.location.replace(redirectUrl)
            } else if (result.error) {
              displayError.textContent = result.error
              buttonElement.innerText = "Save"
              buttonElement.disabled = false
            } else {
              displayError.textContent = "An unexpected error occurred. Contact support for assistance."

              buttonElement.innerText = "Save"
              buttonElement.disabled = false
            }
          })
        }
      })
    })
  }
}
